import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { ChevronLeft } from 'lucide-react'

import { Button } from '@harvey-frontend/components/ui/button'

type HeaderState = {
  expandedSection?: 'acceptable' | 'needs_review' | 'unacceptable'
}

type HeaderProps = {
  title: string
  to?: string
  icon?: React.ReactNode
  isDisabled?: boolean
  showDisabled?: boolean
  state?: HeaderState
}

export const Header = ({
  title,
  to,
  icon,
  isDisabled,
  state,
  showDisabled = true,
}: HeaderProps) => {
  const navigate = useNavigate()
  const navigateTo = to ? () => navigate(to, { state }) : () => navigate(-1)

  return (
    <header
      className="flex items-center border-b bg-primary px-4 py-2"
      data-testid="nav-header"
    >
      <div className="flex flex-1">
        {showDisabled && (
          <Button
            variant="ghost"
            size="xsIcon"
            onClick={navigateTo}
            className="mr-2 active:bg-accent"
            disabled={isDisabled}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
        )}
      </div>
      <div className="flex grow items-center gap-2">
        {icon}
        <span className="mt-0.5 text-sm font-medium">{title}</span>
      </div>
    </header>
  )
}

export default Header
